<script lang="ts">
import { writable } from "svelte/store";
import { find, findResult } from "../api";

import Loading from "../components/loading/Loading.svelte";
import Table from "../components/table/Table.svelte";
import LocalSort from "../components/table/LocalSort.svelte";
import LocalSearch from "../components/table/LocalSearch.svelte";
import { onMount } from "svelte";

import { fileDate, fileSize } from "../tools";


const data        = writable({ df: findResult(), topRequests: findResult(), locks: findResult(), });
const isLoading = writable({ df: false, topRequests: false, locks: false, });

async function getDfData ( ) {
	$isLoading.df = true;

	try {
		$data.df = await find(
			"/status/df"
		);
	} catch (e) {
	}

	$isLoading.df = false;
}

async function getTopRequestsData ( ) {
	$isLoading.topRequests = true;

	try {
		$data.topRequests = await find(
			"/status/top-requests",
			undefined,
			{
				stringToDate: [ "date" ],
			},
		);
	} catch (e) {
	}

	$isLoading.topRequests = false;
}

async function getLocksData ( ) {
	$isLoading.locks = true;

	try {
		$data.locks = await find(
			"/status/locks",
			undefined,
			{
				stringToDate: [ "date" ],
			},
		);
	} catch (e) {
	}

	$isLoading.locks = false;
}

async function getData ( ) {
	await getLocksData();
	await getDfData();
	await getTopRequestsData();
	console.log($data);
}
onMount(getData);
</script>

<div class="status">
	<!-- Disk usage -->
	<LocalSort data="{$data.df.result}" sortKey="filesystem" sortDir="asc" let:sorted let:sortBy let:sortKey let:sortDir>
		<div class="row bg-secondary">
			<div class="col d-flex flex-row align-items-center pt-3 pb-3">
				<button class="btn btn-secondary" on:click="{( ) => getDfData()}"><i class="fas fa-sync"></i></button>
				<h2 class="mb-0">Disk usage</h2>
			</div>
		</div>
		<div class="row position-relative">
			<Table data="{sorted}" class="table table-fixed table-dark">
				<tr slot="thead">
					<th width="40%" class="th-pointer" on:click="{( ) => sortBy("filesystem", "asc")}">
						Filesystem
						{#if sortKey === "filesystem"}
							{#if sortDir === "asc"}⬇{:else}⬆{/if}
						{/if}
					</th>
					<th width="20%" class="th-pointer" on:click="{( ) => sortBy("total", "desc")}">
						Total
						{#if sortKey === "total"}
							{#if sortDir === "asc"}⬇{:else}⬆{/if}
						{/if}
					</th>
					<th width="20%" class="th-pointer" on:click="{( ) => sortBy("used", "desc")}">
						Used
						{#if sortKey === "used"}
							{#if sortDir === "asc"}⬇{:else}⬆{/if}
						{/if}
					</th>
					<th width="20%" class="th-pointer" on:click="{( ) => sortBy("available", "desc")}">
						Available
						{#if sortKey === "available"}
							{#if sortDir === "asc"}⬇{:else}⬆{/if}
						{/if}
					</th>
				</tr>
				<tr slot="tbody" let:item>
					<td>
						{item.filesystem}
					</td>
					<td>
						{fileSize(item.total * 1000)}
					</td>
					<td>
						{fileSize(item.used * 1000)}
					</td>
					<td>
						{fileSize(item.available * 1000)}
					</td>
				</tr>
			</Table>
			<Loading class="bg-dark" isLoading={$isLoading.df} duration="{25}"><div class="loading-spinner"></div></Loading>
		</div>
	</LocalSort>
	<!-- Locks -->
	<div class="row bg-secondary">
		<div class="col d-flex flex-row align-items-center pt-3 pb-3">
			<button class="btn btn-secondary" on:click="{( ) => getLocksData()}"><i class="fas fa-sync"></i></button>
			<h2 class="mb-0">File locks</h2>
		</div>
	</div>
	<div class="row position-relative">
		<Table data="{$data.locks.result}" class="table table-fixed table-dark">
			<tr slot="thead">
				<th width="80%">File</th>
				<th width="20%">Date</th>
			</tr>
			<tr slot="tbody" let:item>
				<td>
					{item.file}
				</td>
				<td>
					{fileDate(item.date)}
				</td>
			</tr>
		</Table>
		<Loading class="bg-dark" isLoading={$isLoading.locks} duration="{25}"><div class="loading-spinner"></div></Loading>
	</div>
	<!-- Top requests -->
<!--
	<div class="row bg-secondary">
		<div class="col d-flex flex-row align-items-center pt-3 pb-3">
			<button class="btn btn-secondary" on:click="{( ) => getTopRequestsData()}"><i class="fas fa-sync"></i></button>
			<h2 class="mb-0">Longest requests in 24 hrs</h2>
		</div>
	</div>
	<div class="row position-relative">
		<Table data="{$data.topRequests.result}" class="table table-fixed table-dark">
			<tr slot="thead">
				<th width="60%">Request</th>
				<th width="20%">Date</th>
				<th width="20%">MS</th>
			</tr>
			<tr slot="tbody" let:item>
				<td>
					<pre class="text-light"><code>{JSON.stringify(item.msu, undefined, "   ")}</code></pre>
				</td>
				<td>
					{fileDate(item.date)}
				</td>
				<td>
					{item.ms}
				</td>
			</tr>
		</Table>
		<Loading class="bg-dark" isLoading={$isLoading.topRequests} duration="{25}"><div class="loading-spinner"></div></Loading>
	</div>
-->
</div>
